import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Ticket } from "lucide-react";
import { Redeem } from "@/lib/api";
import { toast } from "@/components/ui/dialog";

export function RedeemPanel({ onSuccess }: { onSuccess?: () => void }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const c = code.trim();
    if (!c) { toast.warning("请输入兑换码"); return; }
    setLoading(true);
    try {
      const r = await Redeem.redeem(c);
      toast.success(`兑换成功：${r.summary}`);
      setCode("");
      onSuccess?.();
    } catch (e: any) {
      toast.error(e?.body?.message || e?.message || "兑换失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <Ticket className="h-5 w-5 text-primary" />
          <div>
            <div className="font-medium">兑换码</div>
            <div className="text-xs text-muted-foreground">输入兑换码可领取积分或会员天数</div>
          </div>
        </div>
        <div className="flex gap-2">
          <Input value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
            placeholder="请输入兑换码"
            className="font-mono uppercase tracking-wider"
            disabled={loading} />
          <Button onClick={submit} disabled={loading}>{loading ? "兑换中…" : "兑换"}</Button>
        </div>
      </CardContent>
    </Card>
  );
}
